import { gql } from '@apollo/client';

const GET_BANNERS = gql`
  query banners($params: QueryParams, $title: String) {
    banners(params: $params, title: $title) {
      results {
        id
        img
        title
        type
        products {
          id
          name
          description
          variants {
            id
            img
            title
            product {
              id
              name
              description
            }
          }
        }
      }
      info {
        count
        prev
        next
        pages
      }
    }
  }
`;

const DELETE_BANNER = gql`
  mutation deleteBanner($id: ID!) {
    deleteBanner(id: $id)
  }
`;

export { GET_BANNERS, DELETE_BANNER };
